/// <reference types="vite/client" />
var env;
var HUB_PUSHER_KEY = '7b2b7f018df82c59a9cb';
var HUB_PUSHER_CLUSTER = 'mt1'; // In vite mode, process.env.NODE_ENV exists but process is undefined
// In nextJs mode, 'process.env.TEST' is text replaced to whatever the value is in env variables and process is defined

if (typeof process !== 'undefined') {
  if (process.env.NEXT_PUBLIC_HUB_PUSHER_KEY) HUB_PUSHER_KEY = process.env.NEXT_PUBLIC_HUB_PUSHER_KEY;
  if (process.env.NEXT_PUBLIC_HUB_PUSHER_CLUSTER) HUB_PUSHER_CLUSTER = process.env.NEXT_PUBLIC_HUB_PUSHER_CLUSTER;
} else if (import.meta !== undefined) {
  env = import.meta.env;
  if (env.VITE_PUBLIC_HUB_PUSHER_KEY) HUB_PUSHER_KEY = env.VITE_PUBLIC_HUB_PUSHER_KEY;
  if (env.VITE_PUBLIC_HUB_PUSHER_CLUSTER) HUB_PUSHER_CLUSTER = env.VITE_PUBLIC_HUB_PUSHER_CLUSTER;
} else {
  throw 'No env found';
}

export { HUB_PUSHER_CLUSTER, HUB_PUSHER_KEY };